(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('GaeSearch', GaeSearch);

    GaeSearch.$inject = ['$resource'];

    function GaeSearch($resource) {
        var resourceUrl =  'api/_search/gaes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
